import companyPhone from '../../filters/company/company-phone';
import personFullName from '../../filters/person/person-full-name';
import routeName from '../../routes/route-name';
import boardFunctionName from '../../transformers/person/board-function-name';
import column from '../abstract/column';
import vars from '../abstract/vars';
import actions from './actions/index.js';
import api, { modelName } from './api';

export default {
  actions,
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    name: column({ label: 'Imię', format: item => item?.staff?.employee?.person?.name }),
    surname: column({ label: 'Nazwisko', format: item => item?.staff?.employee?.person?.surname }),
    phone: column({ label: 'Telefon', format: item => companyPhone(item?.staff?.employee?.person?.company) }),
    email: column({ label: 'E-mail', format: item => item?.staff?.employee?.person?.email }),
    shares: column({
      label: 'Funkcja',
      component: 'value-status-tooltips',
      items: ({ item }) => item?.boardfunction?.map(e => ({
        label: `${ boardFunctionName.fromValue(e.type) }`,
        tooltip: `Od: ${ e.valid_from || '-' } / Do: ${ e.valid_to || '-' }`,
      })),
    }),
  },
  vars: vars({
    noItemsText: 'Brak członków zarządu',
    sidebarLabel: 'Podgląd członka zarządu',
    softDelete: {
      title: 'Usunięcie członka zarządu',
      text: (item) => `Czy na pewno chcesz usunąć członka zarządu ${ personFullName(item?.staff?.employee?.person) }?`,
      successText: 'Członek zarządu został usunięty.',
    },
  }),
  topRightActions: {
    create: {
      label: 'Dodaj członka zarządu',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push({ name: routeName.partnerStaffBoardMember.store }),
    },
  },
};
